import { takeLatest, put } from 'redux-saga/effects';
import axios from 'axios';
import { CHECK_NETWORK_URL } from '../config';
import { GET_NET_STATUS, SET_NET_STATUS } from '../constants/network';
import { logNative } from '../utils/utils';

function* fetchNetBeat({ url }) {
  try {
    const res = yield axios.get(CHECK_NETWORK_URL);
    if (res.status === 200 && url) {
      window.location.replace(url);
    }
    logNative(`心跳接口${CHECK_NETWORK_URL}, ${url}访问结果：`, res);
    yield put({ type: SET_NET_STATUS, online: res.status === 200 });
  } catch (error) {
    logNative(`心跳接口${CHECK_NETWORK_URL}访问结果(错误)：${error}`, error);
    yield put({ type: SET_NET_STATUS, online: false });
  }
}

export function* watchFetchNetBeat() {
  yield takeLatest(GET_NET_STATUS, fetchNetBeat);
}
